var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":_vm.buscar}},[_vm._v(" Buscar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }